export function toSnakeCase(str: string): string {
  const regex = /[^A-Za-z0-9]/
  const splitedString = str
    .split(/(?=[A-Z_\W])/)
    .map(item => item.replace(regex, ""))
    .filter(Boolean)

  return splitedString.join("_").toLowerCase()
}
